<template>
  <article id="add-contact-person">
    <h3 v-html="model.TitleExtraContact" />
    <p class="extra-margin-bottom" v-html="model.TextExtraContact" />
    <div class="control">
      <h4 v-html="model.LabelExtraContactQuestion" />
      <div class="row">
        <div
          v-for="(item, key) in stepModel.AddExtraContactOptions"
          :key="key"
          class="small-12 medium-3 columns radio-stacked"
        >
          <input
            v-model="stepModel.AddExtraContact"
            :id="'add-extra-contact-' + item.Value"
            :value="item.Value"
            type="radio"
          />
          <label :for="'add-extra-contact-' + item.Value" :disabled="saving">{{
            item.Label
          }}</label>
        </div>
      </div>
      <ValidationError name="add-extra-contact" />
    </div>
    <div v-if="showSelectContact" id="AddExtraContact" class="extra-margin-bottom">
      <p class="extra-margin-bottom" v-html="model.SelectedContactText" />
      <div class="control">
        <fieldset class="radio-inline">
          <div
            v-for="(item, key) in stepModel.ContactOptions.filter((i) => i.IsOfLegalAge)"
            :key="key"
          >
            <Field
              :id="'contact-' + key"
              v-model="vueModel.CreateClaimEntity.SelectedContact"
              :rules="'required'"
              :data-test-create-claim-step4-contact="key"
              type="radio"
              name="contact"
              :value="item"
            />
            <label :for="'contact-' + key">{{ getContactOptionLabelTxt(item) }}</label>
          </div>
        </fieldset>
        <ValidationError name="contact" :overrides="{ required: 'Angiv venligst' }" />
      </div>
      <div v-if="showAddExtraContact">
        <p class="extra-margin-bottom" v-html="model.ExtraContactQuestionText" />
        <div class="control">
          <label
            v-if="model.LabelAndTooltipExtraContactFirstName !== ''"
            for="extra-contact-first-name"
            class="text-question"
            v-html="model.LabelAndTooltipExtraContactFirstName"
          />
          <Field
            id="extra-contact-first-name"
            v-model="vueModel.CreateClaimEntity.ClaimantExtraFirstName"
            :rules="{ required: stepModel.AddExtraContact }"
            type="text"
            name="extra-contact-first-name"
            :label="model.ErrorMessageExtraContactFirstName"
            :disabled="saving"
          />
          <ValidationError name="extra-contact-first-name" />
        </div>
        <div class="control">
          <label
            for="extra-contact-last-name"
            class="text-question"
            v-html="model.LabelAndTooltipExtraContactLastName"
          />
          <Field
            id="extra-contact-last-name"
            v-model="vueModel.CreateClaimEntity.ClaimantExtraLastName"
            :rules="{ required: stepModel.AddExtraContact }"
            type="text"
            name="extra-contact-last-name"
            :label="model.ErrorMessageExtraContactLastName"
            :disabled="saving"
          />
          <ValidationError name="extra-contact-last-name" />
        </div>
        <div class="control">
          <div class="row">
            <div class="small-12 medium-4 columns">
              <label
                for="extra-contact-phone"
                class="text-question"
                v-html="model.LabelAndTooltipExtraContactPhone"
              />
              <Field
                id="extra-contact-phone"
                v-model="vueModel.CreateClaimEntity.ClaimantExtraTelephone.PhoneNumber"
                :rules="{ required: stepModel.AddExtraContact, numeric: true, min: 8 }"
                name="extra-contact-phone"
                type="tel"
                maxlength="8"
                :label="model.ErrorMessageExtraContactPhone"
                :disabled="saving"
              />
              <ValidationError name="extra-contact-phone" />
            </div>
            <div class="small-12 medium-8 columns">
              <label
                for="extra-contact-email"
                class="text-question"
                v-html="model.LabelAndTooltipExtraContactEmail"
              />
              <Field
                id="extra-contact-email"
                v-model="vueModel.CreateClaimEntity.ClaimantExtraEmail.EmailAddress"
                :rules="{ email: true }"
                name="extra-contact-email"
                type="email"
                :label="model.ErrorMessageExtraContactEmail"
                :disabled="saving"
              />
              <ValidationError name="extra-contact-email" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="stepModel.ContactOptions.filter((i) => !i.IsOfLegalAge).length > 0">
        <p v-html="model.StartUnderagedText" />
        <ul>
          <li
            v-for="(item, key) in stepModel.ContactOptions.filter((i) => !i.IsOfLegalAge)"
            :key="key"
            v-html="item.Name"
          />
        </ul>
        <p v-html="model.EndUnderagedText" />
      </div>
    </div>
  </article>
</template>
<script>
export default {
  name: 'AddContactPerson',
  props: {
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    model: {
      type: Object,
      default() {
        return {};
      }
    },
    stepModel: {
      type: Object,
      default() {
        return {};
      }
    },
    saving: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  computed: {
    showSelectContact() {
      return this.stepModel.AddExtraContact;
    },
    showAddExtraContact() {
      return (
        this.stepModel.AddExtraContact &&
        this.vueModel.CreateClaimEntity.SelectedContact?.ContactId === '-1'
      );
    }
  },
  watch: {
    'vueModel.CreateClaimEntity.SelectedContact': {
      handler(val) {
        if (val && val.ContactId) {
          this.resetExtraContact();
        }
      },
      deep: true
    },
    'stepModel.AddExtraContact': function (val) {
      if (!val) {
        this.resetSelectedContact();
        this.resetExtraContact();
      }
    }
  },
  methods: {
    resetExtraContact() {
      this.vueModel.CreateClaimEntity.ClaimantExtraFirstName = null;
      this.vueModel.CreateClaimEntity.ClaimantExtraLastName = null;
      this.vueModel.CreateClaimEntity.ClaimantExtraTelephone.PhoneNumber = null;
      this.vueModel.CreateClaimEntity.ClaimantExtraEmail.EmailAddress = null;
      // this.$validator.reset();
    },
    resetSelectedContact() {
      this.vueModel.CreateClaimEntity.SelectedContact = null;
      // this.$validator.reset();
    },
    getContactOptionLabelTxt(contactOption) {
      if (
        contactOption.RelationshipType === 'PoaLogin' ||
        contactOption.RelationshipType === 'PoaHolder' ||
        contactOption.RelationshipType === 'Other'
      ) {
        return contactOption.Description;
      }
      return contactOption.Name;
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.extra-margin-bottom {
  margin-bottom: rem-calc(30px);
}
</style>
